import {axios} from "@/utils/request";

// 新增包裹信息 // 更新包裹信息
export function getaddTransport (parameter) {
  return axios({
    url: '/order/transport' + (parameter.transportId ? '/updateTransport' : '/addTransport'),
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 删除包裹信息
export function getdelTransport (parameter) {
  return axios({
    url: '/order/transport' +'/delTransport',
    method: 'get',
    params: parameter,
  })
}
// 配件信息下拉
export function queryMasterAccessory (parameter) {
  return axios({
    url: '/master/masterOrder/queryMasterAccessory',
    method: 'get',
    params: parameter,
  })
}
// 新增订单配件 // 更新订单配件
export function addOrderAccessory (parameter) {
  return axios({
    url: '/order/accessory' + (parameter.orderAccessoryId ? '/updateOrderAccessory' : '/addOrderAccessory'),
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 退回配件
export function getreturnOrderAccessory (parameter) {
  return axios({
    url: '/order/accessory' +'/returnOrderAccessory',
    method: 'get',
    params: parameter,
  })
}
// 作废配件
export function getinvalidOrderAccessory (parameter) {
  return axios({
    url: '/order/accessory' +'/invalidOrderAccessory',
    method: 'get',
    params: parameter,
  })
}
// 获取物流信息
export function getTransportInfo (parameter) {
  return axios({
    url: '/order/transport' +'/getTransportInfo',
    method: 'get',
    params: parameter,
  })
}
// 获取金额信息
export function masterPrice (parameter) {
  return axios({
    url: '/master/masterOrder/masterPrice',
    method: 'get',
    params: parameter,
  })
}
// 企业要求
export function masterDemand (parameter) {
  return axios({
    url: '/master/masterOrder/masterDemand',
    method: 'get',
    params: parameter,
  })
}
// 发起问题反馈
export function getaddFeedback(parameter) {
  return axios({
    url: 'backlog/feedback/addFeedback',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 1.3.2获取登录人问题反馈权限
export function getFeedbackAuthority (parameter) {
  return axios({
    url: 'backlog/feedback/getFeedbackAuthority',
    method: 'get',
    params: parameter,
  })
}
// 发起 问题反馈下拉
export function getprocessor (parameter) {
  return axios({
    url: '/backlog/pendingMatter/processor',
    method: 'get',
    params: parameter,
  })
}
// tab页 问题反馈数据
export function getfeedbacklist (parameter) {
  return axios({
    url: '/backlog/app/feedback/list',
    method: 'get',
    params: parameter,
  })
}
// tab页 销单资料
export function getsaleOrderData (parameter) {
  return axios({
    url: '/order/order/saleOrderData',
    method: 'get',
    params: parameter,
  })
}
// 提交 tab页 销单资料
export function getsaleDataSave (parameter) {
  return axios({
    url: '/order/orderInstall/saleDataSave',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 禁用图片、视频
export function getdisablesale (parameter) {
  return axios({
    url: '/order/cost/disable',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 删除图片、视频
export function getdeletesale (parameter) {
  return axios({
    url: '/order/cost/delete',
    method: 'post',
    params: parameter,
  })
}
// 字典表数据
export function getfinddictAll (parameter) {
  return axios({
    url:  '/system/dict/data/findAll',
    method: 'get',
    params: parameter,
  })
}
// 列表数据
export function getOrderList (parameter) {
  return axios({
    url:  '/master/masterOrder/orderList',
    method: 'get',
    params: parameter,
  })
}
// 订单详情数据
export function getOrderDetails (parameter) {
  return axios({
    url:  '/master/masterOrder/getOrderDetails',
    method: 'get',
    params: parameter,
  })
}
// 查询师傅备注数据
export function getMasterRemark (parameter) {
  return axios({
    url:  '/master/masterOrder/getMasterRemark',
    method: 'get',
    params: parameter,
  })
}
// 添加师傅备注数据
export function addMasterRemark (parameter) {
  return axios({
    url:  '/master/masterOrder/addMasterRemark',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 修改师傅备注数据
export function updateMasterRemark (parameter) {
  return axios({
    url:  '/master/masterOrder/updateMasterRemark',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 删除师傅备注数据
export function deleteMasterRemark (parameter) {
  return axios({
    url:  '/master/masterOrder/deleteMasterRemark',
    method: 'get',
    params: parameter,
  })
}
// 查询用户订单排序
export function getUserOrderSort (parameter) {
  return axios({
    url: '/order/sort/getUserOrderSort',
    method: 'get',
    params: parameter,
  })
}
// 新增订单排序
export function getaddUserOrderSort (parameter) {
  return axios({
    url: '/order/sort/addUserOrderSort',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 省
export function getselectAllProvince (parameter) {
  return axios({
    url: '/basicdata/province/selectAllProvince',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 市
export function getselectCityName (parameter) {
  return axios({
    url: '/basicdata/city/selectCityName',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 区
export function getselectAreaName (parameter) {
  return axios({
    url: '/basicdata/area/selectAreaName',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 订单类型
export function getOrderTypeList (parameter) {
  return axios({
    url: `/basicdata/orderType/getList/${parameter}`,
    method: 'get',
  })
}
// 获取查询品牌下拉框数据
export function getSelectBrand (parameter) {
  return axios({
    url: '/enterprise/brand/selectBrand',
    method: 'get',
    params: parameter,
  })
}
// 获取查询型号下拉框数据
export function getSelectModel (parameter) {
  return axios({
    url: '/enterprise/model/selectModel',
    method: 'get',
    params: parameter,
  })
}

export function getorderInfo(parameter) {
  return axios({
    url: '/order/DispatchOrder/orderInfo',
    method: 'get',
    params: parameter,
  })
}

export function receiveOrder(parameter) {
  return axios({
    url: '/order/wechat/process/receiveOrder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}